var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 18H3.9375C1.76288 18 0 16.2371 0 14.0625V3.9375C0 1.76288 1.76288 0 3.9375 0H14.0625C16.2371 0 18 1.76288 18 3.9375V14.0625C18 16.2371 16.2371 18 14.0625 18Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0008 14.0629V13.1986L15.2088 11.3693H18.0008V10.4219H10.4219V18.0008H11.3692V12.2514L17.3786 16.1885C17.5914 15.8572 17.7557 15.4917 17.862 15.1023",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.264762 15.4851C0.360668 15.7326 0.480691 15.9681 0.62223 16.1885L6.63156 12.2514V18.0008H7.57891V10.4219H0V11.3693H2.79207L0 13.1986V14.0633C0 14.2147 0.00885938 14.364 0.0254883 14.511",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.07134V4.80227L2.79207 6.63159H0V7.57895H7.57895V0H6.63159V5.74945L0.62223 1.8123C0.388687 2.17593 0.213504 2.58054 0.109477 3.01289",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7309 2.50203C17.6359 2.25949 17.5175 2.02862 17.3786 1.81227L11.3692 5.74945V0H10.4219V7.57895H18.0008V6.63159H15.2088L18.0008 4.80227V3.9375C18.0008 3.7807 17.9914 3.62609 17.9735 3.47407",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4211 0H7.57895V7.57895H0V10.4211H7.57895V18H10.4211V10.4211H18V7.57895H10.4211V0Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8634 11.3711L0.0234375 14.5128C0.0618984 14.8525 0.143461 15.1791 0.262746 15.487L6.60349 11.3711H4.8634V11.3711Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1094 11.3711L17.8604 15.1042C17.9507 14.7732 17.9993 14.4249 17.9993 14.0652V14.0648L13.8495 11.3711L12.1094 11.3711Z",
    fill: "#D80027"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6842 6.63042L0.109477 3.01172C0.0380742 3.3083 0 3.61785 0 3.93633V4.07017L3.94411 6.63042H5.6842Z",
    fill: "#D80027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1112 6.63343L17.9754 3.47591C17.9356 3.13686 17.853 2.81096 17.7327 2.50391L11.3711 6.63343H13.1112Z",
    fill: "#D80027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGb);
export default __webpack_public_path__ + "static/media/icon-gb.eb1abf92.svg";
export { ForwardRef as ReactComponent };